/**
 * WCAG 2.5.8 / ACCESS-03 touch-target minimums.
 * Icon-only controls: hit area must be at least 24×24 CSS px.
 * Primary CTAs: ~44×44 CSS px (see button theme md/lg).
 */
export const A11Y_ICON_TARGET_MIN = '24px';

/** Header utility icons — 32×32 hit (above the 24px floor). */
export const HEADER_ICON_HIT = '32px';

/** Visual size for header / modal icon glyphs (inside 24px hit area). */
export const A11Y_ICON_GLYPH_SIZE = '20px';
